export default __webpack_public_path__ + "static/satheeskumar-uthayakumar-9583e48a1487eea8d4d011fd45c7cd93.jpg";